import { render, staticRenderFns } from "./VipButton.vue?vue&type=template&id=4706027f&scoped=true&"
import script from "./VipButton.vue?vue&type=script&lang=ts&"
export * from "./VipButton.vue?vue&type=script&lang=ts&"
import style0 from "./VipButton.vue?vue&type=style&index=0&id=4706027f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4706027f",
  null
  
)

export default component.exports